import React from 'react'
import { Table } from '../../../admin/components/Table/Table'

const DevolutionByUser = ({ devolutions }) => {
    return (
        <div>
            <Table>
                <thead>
                    <tr>

                        <th>orden</th>
                        <th>items </th>
                        <th>items resueltos</th>
                    </tr>

                </thead>
                <tbody>
                    {
                        devolutions.map(devolution => (
                            <tr onClick={e => {

                                if (!devolution.solved) {
                                   
                                }
                            }}>

                                <td>{devolution.productOrderId.code}</td>
                                <td>{devolution.quantityDetails}</td>
                                <td>{devolution.quantitySolved}</td>
                            </tr>
                        ))
                    }

                </tbody>
            </Table>
        </div>
    )
}

export default DevolutionByUser